export const catchError = (ex, onError) => dispatch => {
    console.log(ex);

    if (ex.response) {
        ex.response.json().then(error => dispatch(onError(error)));
    } else {
        dispatch(onError(ex));
    }
}